// ABOUTME: The connection indicator steps aside while a rail panel (bag / favourites / privacy) is open on a phone, where the panel spans the
// ABOUTME: frame and no left clamp can clear a centred item (owner round 2, 2026-10-07). Works with every experiment toggle off: this is production.

// Which compositions hide it, decided from measurement (voice_first_matrix_check.js, the `panel` piece vs the `indicator`):
//  - mobile  The centred indicator sits at the top of the panel header at EVERY phone width, inside the panel's box (390x844 render:
//            "ONLINE" between the title and the close ✕). Nothing can be clamped clear of a centred item there, so it hides.
//  - desktop It does NOT hide. The left rail's panel is capped to the wordmark and the indicator sits in the opposite corner; the right
//            rail's is capped to clear the centred indicator itself (railGeometry.panelWidthClearOf*). Hiding a corner indicator that
//            nothing reaches would change the shipped laptop UI for no gain.
const HIDES_ON = new Set(['mobile']);
const PANEL_KINDS = new Set(['CART', 'WISHLIST', 'PRIVACY']);

/** Added to the indicator's own classes while hidden; the fade is CSS (index.css), and `prefers-reduced-motion` turns it into a cut there. */
export const INDICATOR_AWAY_CLASS = 'ui-indicator-away';

/**
 * @param {string|null|undefined} expanded the panel the rail / chip stack is actually showing (App's `overlay`, minus a Privacy panel the
 *   collection menu hosts under the hamburger — that one hangs BELOW the indicator and never reaches it)
 * @param {'desktop'|'mobile'} composition
 * @returns {boolean}
 */
export const indicatorHiddenFor = (expanded, composition) => PANEL_KINDS.has(expanded) && HIDES_ON.has(composition);

// Frozen singletons: spreading the "visible" answer adds NOTHING to the markup, so a closed panel renders the indicator byte-for-byte as before.
const VISIBLE = Object.freeze({ hidden: false, className: '', ariaHidden: undefined });
const AWAY = Object.freeze({ hidden: true, className: ` ${INDICATOR_AWAY_CLASS}`, ariaHidden: true });

/**
 * @param {{ expanded: string|null|undefined, composition: 'desktop'|'mobile' }} p
 * @returns {{ hidden: boolean, className: string, ariaHidden: (true|undefined) }} `className` leads with a space (or is empty) so it
 *   concatenates straight onto the indicator's class list; `ariaHidden` is `undefined` while visible so no attribute is rendered.
 */
export default function usePanelIndicator({ expanded, composition }) {
  return indicatorHiddenFor(expanded, composition) ? AWAY : VISIBLE;
}
